module.exports = __webpack_public_path__ + "media/img/home/directions/mobile/direction2-028330c0ff12df9b632a558069225c00.svg";